import { SGA_SPEND_EVIDENCE_KEYS } from './evidenceKeys';
import { DECISION_AGENT_SOURCE_CLASSES } from './sourceClasses';

/**
 * Orthogonal evidence-mechanism identities for sources that can share a
 * canonical source class while carrying materially different provenance and
 * comparison semantics.
 */
export const REFERENCE_EVIDENCE_MECHANISMS = {
  citedPublicBenchmark: 'cited_public_benchmark',
  directionalBenchmarkBand: 'directional_benchmark_band',
} as const;

export type ReferenceEvidenceMechanism =
  (typeof REFERENCE_EVIDENCE_MECHANISMS)[keyof typeof REFERENCE_EVIDENCE_MECHANISMS];

export const CITED_PUBLIC_BENCHMARK_PROFILE_CONTRACT = {
  referenceMechanism: REFERENCE_EVIDENCE_MECHANISMS.citedPublicBenchmark,
  contextKind: 'decision_agent:sga_spend:cited_public_benchmark_profile',
  schemaVersion: 'sga_cited_public_benchmark_profile_v1',
  evidenceClass: SGA_SPEND_EVIDENCE_KEYS.benchmarkProfileArtifact,
  sourceClass: DECISION_AGENT_SOURCE_CLASSES.industryReference,
  denominator: 'gross_revenue',
  denominatorFact: 'RevenueFromContractWithCustomerExcludingAssessedTax',
  admittedNumeratorFacts: [
    'GeneralAndAdministrativeExpense',
    'OtherSellingGeneralAndAdministrativeExpense',
    'SellingGeneralAndAdministrativeExpense',
  ],
} as const;
